import React, { useState } from 'react';
import GeneralSettingsSection from './GeneralSettingsSection';
import CustomizeReportsSection from './CustomizeReportsSection';
import TemplatesSection from './TemplatesSection';
import LivePreviewSection from './LivePreviewSection';
import ExportLogSection from './ExportLogSection';

const getUser = () => { try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; } };

const TABS = [
  { id: 'general', label: 'الإعدادات العامة' },
  { id: 'customize', label: 'تخصيص التقارير' },
  { id: 'templates', label: 'القوالب' },
  { id: 'preview', label: 'المعاينة المباشرة' },
  { id: 'log', label: 'سجل التصدير' },
];

export default function ReportStudio() {
  const [tab, setTab] = useState('general');
  const user = getUser();
  const canManage = !!(user?.is_super_admin || user?.role === 'admin' || user?.role === 'manager');

  return (
    <div className="space-y-4" dir="rtl" data-testid="report-studio">
      <div>
        <h2 className="text-lg font-bold text-slate-900">استوديو التقارير</h2>
        <p className="text-sm text-slate-500">المكان المركزي للتحكم في هوية وشكل وتنسيق تقارير PDF وExcel في المنصة</p>
      </div>

      <div className="flex flex-wrap gap-1 overflow-x-auto rounded-xl border border-slate-200 bg-white p-1" data-testid="rs-tabs">
        {TABS.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)} className={`flex-1 whitespace-nowrap rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${tab === t.id ? 'bg-[#16233b] text-white' : 'text-slate-600 hover:bg-slate-50'}`} data-testid={`rs-tab-${t.id}`}>
            {t.label}
          </button>
        ))}
      </div>

      {!canManage && <div className="rounded-lg bg-amber-50 px-3 py-2 text-xs text-amber-700" data-testid="rs-readonly-note">يمكنك استعراض الإعدادات والمعاينة والسجل، وحفظ التغييرات متاح فقط لمدير المنشأة أو المسؤول.</div>}

      {tab === 'general' && <GeneralSettingsSection canManage={canManage} />}
      {tab === 'customize' && <CustomizeReportsSection canManage={canManage} />}
      {tab === 'templates' && <TemplatesSection canManage={canManage} />}
      {tab === 'preview' && <LivePreviewSection />}
      {tab === 'log' && <ExportLogSection />}
    </div>
  );
}
